import type { InputProps } from "./Input.types";
import { getInputStyles } from "./Input.styles";
import { Icon } from "../../atoms/Icon";
export const Input = ({
  id,
  label,
  iconLeft,
  iconRight,
  isPassword = false,
  onIconClick,
  state = "default",
  variant = "default",
  disabled,
  readonly = false,
  helperText,
  ...rest
}: InputProps) => {
  const styles = getInputStyles({
    state,
    variant,
    disabled,
    iconLeft,
    readonly,
    clickable: onIconClick !== undefined,
  });

  return (
    <div className={styles.wrapper}>
      {label && (
        <label
          htmlFor={id}
          className={styles.label}
        >
          {label}
        </label>
      )}

      <div className={styles.inputContainer}>
        <input
          id={id}
          className={styles.input}
          disabled={disabled}
          type={isPassword ? "password" : "text"}
          {...rest}
        />

        {(iconLeft || iconRight) && (
          <button
            type="button"
            onClick={onIconClick}
            disabled={disabled}
            className={styles.icon}
            aria-label="Ação do Input"
          >
            <Icon name={iconRight || iconLeft || ""} />
          </button>
        )}
      </div>
      {helperText && <p className={styles.helperText}>{helperText}</p>}
    </div>
  );
};
